import IconCancel from '@fortuneo/ui-icons/general/IconCancel'
import { ModalUI } from '@ui/modal/modal'
import React, { type FC } from 'react'

import { errorMessage } from './message'

type Props = {
  codes: Array<number | string>
  visible: boolean
  onClose: () => void
}

const getErrorMessage = (code: number | string): string =>
  errorMessage[code.toString()] || errorMessage['0']

const DialogError: FC<Props> = ({ codes, visible, onClose }) => (
  <ModalUI
    visible={visible}
    buttons={[
      {
        // todo créer un hoc pour le tracking d'une fonction
        onClick: onClose,
        variant: 'outline',
        children: 'Fermer',
      },
    ]}
    onClose={onClose}
  >
    <div className="flex flex-col items-center gap-5 pb-5">
      <IconCancel className="fill-theme-warning-main" size={62} />
      <span className="text-center text-135 font-medium">
        Une erreur est survenue
      </span>
    </div>
    {(codes || []).map((code, i) => (
      <p key={i} className="text-center">
        {getErrorMessage(code)}
      </p>
    ))}
  </ModalUI>
)

export default DialogError
